import {checkIfCityHasWorkingArsenal} from "./checkIfCityHasWorkingArsenal";
import {calcRemainingSizeForRecruitment} from "./calcRemainingSizeForRecruitment";
import {
  RECRUITMENT_SIZE_WITH_COINS_DEFAULT,
  RECRUITMENT_SIZE_WITH_COINS_WITH_ARSENAL
} from "../../../configs/recruitment";

export const calcCoinsRecruitmentSize = (city, playerId, units, selectedUnit, pendingRecruitmentActions, hexes, specialBuildings, buildingsDamage) => {
  const hasArsenal = checkIfCityHasWorkingArsenal(city, playerId, units, hexes, specialBuildings, buildingsDamage);
  const recruitmentSize = hasArsenal ? RECRUITMENT_SIZE_WITH_COINS_WITH_ARSENAL : RECRUITMENT_SIZE_WITH_COINS_DEFAULT;

  // unit.maxSize - фактический максимум уже созданного отряда (для большинства фракций
  // совпадает со статическим конфигом типа, но у великанов увеличен - см. createUnit)
  const remainingSizeForRecruitment = calcRemainingSizeForRecruitment(selectedUnit, selectedUnit.maxSize, pendingRecruitmentActions);

  return Math.min(recruitmentSize, remainingSizeForRecruitment);
};
